module.exports = __webpack_public_path__ + "img/sign-13.49c52357.jpg";